import { Link } from "react-router-dom";

import becomeMemberImg from "../../../assets/images/homepage/Images/Become a member photo.jpg";
import listBusinessImg from "../../../assets/images/homepage/Images/List your business photo.jpg";
import downloadAppImg from "../../../assets/images/homepage/Images/Download the app.jpg";

import * as routes from "../../../utils/routes";

import {
  Container,
  CardsWrapper,
  Card,
  CardImage,
  CardBody,
  CardTitle,
  CardText,
} from "./styles";

const ThreeCardsSection = () => {
  return (
    <Container>
      <CardsWrapper>
        <Card as={Link} to={routes.SIGNUP}>
          <CardImage src={becomeMemberImg} alt="Become a member" />
          <CardBody>
            <CardTitle>Become a member</CardTitle>
            <CardText>
              Enjoy unlimited classes + access to one gym or studio for the month. Stay where you belong!
            </CardText>
          </CardBody>
        </Card>

        <Card as={Link} to={routes.LIST_YOUR_BUSINESS}>
          <CardImage src={listBusinessImg} alt="List your business" />
          <CardBody>
            <CardTitle>List your business</CardTitle>
            <CardText>
              Welcome new faces committed to you for a full-month. Convert them into long-term members with our help.
            </CardText>
          </CardBody>
        </Card>

        <Card as="a" href="https://apps.apple.com/us/app/jackedrabbit/id6747449627" target="_blank" rel="noopener noreferrer">
          <CardImage src={downloadAppImg} alt="Download the app" />
          <CardBody>
            <CardTitle>Download the app</CardTitle>
            <CardText>
              Explore the best gyms and studios in your area. Start your first trial in minutes!
            </CardText>
          </CardBody>
        </Card>
      </CardsWrapper>
    </Container>
  );
};

export default ThreeCardsSection;
